import { ResourceOriginEntity } from '../entities/resource-origin-entity';

export default class State {
  loaded = false;

  items: Array<ResourceOriginEntity> = [];
}
